<template>
  <div class="wrapper">
    <div :style="{maxWidth: maxWidth}" style="margin: 0 auto;">
      <ali-player
          v-if="aliVid"
          ref="player"
          :useEncrypt="useEncrypt"
          :playAuth="useEncrypt? playAuth : null"
          :source="useEncrypt ? null : source"
          :user-ratio="4 / 3"
          :video-id="aliVid"
          outCourse></ali-player>
          <div v-show="noReplay" style="position: relative;padding-top: 75%;">
            <div  class="cover">
              <div class="tips">{{$t('course.NoReplay')}}</div>
            </div>
          </div>
      </div>
  </div>
</template>
<script>
import AliPlayer from '@ca/components/player/AliPlayer'
const maxHeight = Math.min(window.innerHeight - 220, 768)

export default {
  name: 'ReplayVideo',
  components: {
    'ali-player': AliPlayer
  },
  computed: {
    useEncrypt () {
      return this.$parent.useEncrypt
    },
    aliVid () {
      if (this.$parent.replay_play_auth) {
        return this.$parent.replay_play_auth.video_id
      } else {
        return 0
      }
    },
    playAuth () {
      if (this.$parent.replay_play_auth) {
        return this.$parent.replay_play_auth.play_auth
      } else {
        return null
      }
    },
    liveUrls () {
      const { rtmp, flv, m3u8 } = this.$parent.live_play_url
      if (rtmp && flv && m3u8) {
        return [rtmp, flv, m3u8]
      } else {
        return []
      }
    },
    source () {
      if (this.$parent.replay_play_url) {
        const source = {}
        this.$parent.replay_play_url.forEach(item => {
          source[item.definition] = item.url
        })
        return JSON.stringify(source)
      } else {
        return null
      }
    },
    noReplay () {
      return !this.playAuth && !this.source
    }
  },
  data () {
    return {
      maxWidth: maxHeight / 0.75 + 'px',
      player: null
    }
  },
  methods: {
    goRoute (routePath) {
      this.$router.push(routePath)
    },
    addEvent () {
      window.addEventListener('resize', () => {
      })
    }
  },
  mounted () {
    // this.addEvent()
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.badge {
  margin-right: 8px;
}
.cover{
    position: absolute;
    background: #52545a;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .tips{
      position: absolute;
      top: 50%;
      margin-top: -50px;
      width: 100%;
      color: #fff;
      text-align: center;
    }
}
</style>
